interface ImageMagickState {
  loading: boolean;
  loaded: boolean;
  failed: boolean;
}

export default ImageMagickState;

export const initialState: ImageMagickState = {
  loading: false,
  loaded: false,
  failed: false
};
